class Regex {
    public telephone() : RegExp {
        return new RegExp(
            /^(\+){0,1}[0-9]{2,16}$/gm
        );
    }
    public mail() : RegExp {
        return new RegExp(
          /^([a-zA-Z0-9_.-]+@[\da-zA-Z.-]+\.[a-z.]{2,6})$/gm
        );
    }

    public mdpLongueur() : RegExp {
        return new RegExp(
            /^.{8,64}$/gm
        );
    }

    public mdpMinuscule() : RegExp {
        return new RegExp(
            /^.*[a-z].*$/gm
        );
    }

    public mdpMajuscule() : RegExp {
        return new RegExp(
            /^.*[A-Z].*$/gm
        );
    }

    public mdpCaractereSepcial() : RegExp {
        return new RegExp(
            /^.*[#?!@$%^&*-].*$/gm
        );
    }

    public mdpNombre() : RegExp {
        return new RegExp(
            /^.*[0-9].*$/gm
        );
    }
}

export default new Regex();
